module.exports = __webpack_public_path__ + "static/media/icon-utilizados.2c77de23.svg";